// 🧿 طلسم محافظ فایل
import React from "react";
// Common Components
import { TabBox } from "src/Components";
// Local Component
import EnterPairPosition from "./EnterPairPosition";
import OptionDomain from "./OptionDomain";
import RollCalculator from "./RollCalculator";
import Offset from "./Offset";

enum ActiveTab {
  OptionDomain = 0, // دامنه نماد
  EnterPairPosition = 2, // ورود به پوزیشن
  DownRollCalculator = 3, // رول به پایین
  UpRollCalculator = 4, // رول به بالا
  EmergencyRollCalculator = 5, // رول اضطراری
  Offset = 6, // آفست کاوردکال
  FixedPriceEntry = 7, // ورود با تعیین قیمت
}

const tabsChildren = [
  { index: ActiveTab.OptionDomain, title: "دامنه نماد" },
  { index: ActiveTab.EnterPairPosition, title: "ورود به پوزیشن" },
  { index: ActiveTab.DownRollCalculator, title: "رول-کاهش ریسک" },
  { index: ActiveTab.UpRollCalculator, title: "رول-افزایش بازده" },
  { index: ActiveTab.EmergencyRollCalculator, title: "رول اضطراری" },
  { index: ActiveTab.Offset, title: "آفست کاوردکال" },
  { index: ActiveTab.FixedPriceEntry, title: "ورود با تعیین قیمت" },
];

const CoveredCall = () => {
  // local state
  const [activeTab, setActiveTab] = React.useState<number>(
    ActiveTab.EnterPairPosition,
  );

  const Tabs = React.useMemo(() => {
    switch (activeTab) {
      case ActiveTab.EnterPairPosition:
        return <EnterPairPosition key="live-price-entry" />;
      case ActiveTab.OptionDomain:
        return <OptionDomain />;
      case ActiveTab.DownRollCalculator:
        return <RollCalculator position="down" />;
      case ActiveTab.UpRollCalculator:
        return <RollCalculator position="up" />;
      case ActiveTab.EmergencyRollCalculator:
        return <RollCalculator position="emergency" />;
      case ActiveTab.Offset:
        return <Offset />;
      case ActiveTab.FixedPriceEntry:
        return <EnterPairPosition key="fixed-price-entry" useFixedBasePrices />;
      default:
        return <></>;
    }
  }, [activeTab]);

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full h-full">
      <div className="w-min">
        <TabBox
          activeTab={activeTab}
          children={tabsChildren}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {Tabs}
    </div>
  );
};
export default CoveredCall;
